import React, { useState } from 'react'

import { Box, Menu, MenuItem, Typography } from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'
import clsx from 'clsx'

import useStyles from './styles'

const OTHERS_CHIP_ID = 'others'

const ChipsFilter = ({ chips, activeChip, onChipChange, otherCategories }) => {
  const classes = useStyles()
  const [menuAnchor, setMenuAnchor] = useState(null)

  const isOthersActive = otherCategories?.some(
    (category) => category.id === activeChip,
  )

  const handleOthersClick = (event) => {
    setMenuAnchor(event.currentTarget)
  }

  const handleMenuClose = () => {
    setMenuAnchor(null)
  }

  const handleOtherCategorySelect = (categoryId) => {
    onChipChange(categoryId)
    handleMenuClose()
  }

  return (
    <Box className={classes.root}>
      {chips.map((chip) => {
        if (chip.id === OTHERS_CHIP_ID) {
          return (
            <React.Fragment key={chip.id}>
              <Typography
                variant="body2"
                className={clsx(classes.chip, classes.chipOthers, {
                  [classes.chipActive]: isOthersActive,
                })}
                onClick={handleOthersClick}
              >
                {chip.label}
                <ExpandMore className={classes.expandIcon} />
              </Typography>
              <Menu
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={handleMenuClose}
              >
                {otherCategories?.map((category) => (
                  <MenuItem
                    key={category.id}
                    selected={activeChip === category.id}
                    onClick={() => handleOtherCategorySelect(category.id)}
                  >
                    <Typography variant="body2">{category.label}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </React.Fragment>
          )
        }

        return (
          <Typography
            variant="body2"
            key={chip?.id}
            component="span"
            className={clsx(classes.chip, {
              [classes.chipActive]: activeChip === chip.id,
            })}
            onClick={() => onChipChange(chip.id)}
          >
            {chip.label}
          </Typography>
        )
      })}
    </Box>
  )
}

export default ChipsFilter
